export const CONTROLLER_VALUES_STALE_AFTER_MS = 7000;

export function getControllerConnectionStatus(isActive, lastReceived, now = Date.now()) {
  if (!isActive) {
    return 'bad';
  }

  return now - lastReceived > CONTROLLER_VALUES_STALE_AFTER_MS ? 'issues' : 'good';
}

export function recordControllerValuesReceived(connection, receivedAt = Date.now()) {
  connection.last_received = receivedAt;

  if (connection.status === 'issues') {
    connection.status = 'good';
  }
}
